import { useLocation } from 'react-router-dom';
import { ENV_VARS } from '../../utils/constants';
import { usePlatformAction } from '../../store/platform/platformAction';
import { useEffect, useState } from 'react';
import Loader from '../../components/loader/Loader';
import ErrorAlert from './components/ErrorAlert';
import { useSelector } from 'react-redux';
import { selectPlatorfom } from '../../store/platform/platformSlice';

const quantwisePlatformId = ENV_VARS.QUANTWISE_CONSTANT.platformId;

export default function Quantwise() {
  const { pathname } = useLocation();
  const { platformLogin } = usePlatformAction();
  const [platformUrl, setPlatformUrl] = useState<string | null>(null);

  const { platformLoginLoading } = useSelector(selectPlatorfom);

  const route = pathname.split('/').at(-1);

  useEffect(() => {
    platformLogin(quantwisePlatformId).then((res) =>
      setPlatformUrl(res?.data?.redirectUri)
    );
  }, [route]);

  const url = `${platformUrl}&returnTo=${route === 'dashboard' ? '/' : `/${route}`}`;

  if (platformUrl === null || platformLoginLoading) {
    return <Loader />;
  }

  if (platformUrl === undefined) {
    return <ErrorAlert />;
  }

  return (
    <iframe
      src={url}
      style={{
        width: '100%',
        height: '90vh',
        border: 'none',
      }}
      title="Quantwise"
    />
  );
}
